import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';
import { DashboardLayout } from './components/layout/DashboardLayout';
import { AuthProvider } from './contexts/AuthContext';
import { NetworkScanJobProvider } from './contexts/NetworkScanJobContext';
import { DashboardPage } from './pages/DashboardPage';
import { LoginPage } from './pages/LoginPage';
import { PlatformOverviewPage } from './pages/PlatformOverviewPage';
import { ScenariosPage } from './pages/ScenariosPage';
import { AgentsPage } from './pages/AgentsPage';
import { EvolutionPage } from './pages/EvolutionPage';
import { ConfigPage } from './pages/ConfigPage';
import { ReportsPage } from './pages/ReportsPage';
import SimulationPage from './pages/SimulationPage';
import { LogsPage } from './pages/LogsPage';
import AssetsPage from './pages/AssetsPage';
import NetworkScanPage from './pages/NetworkScanPage';
import CompliancePage from './pages/CompliancePage';
import VerificationLoopPage from './pages/VerificationLoopPage';
import { AutonomousPipelinePage } from './pages/AutonomousPipelinePage';
import { ExecutorRunsPage } from './pages/ExecutorRunsPage';
import { ExecutorRunDetailsPage } from './pages/ExecutorRunDetailsPage';
import { GraphFindingsPage } from './pages/GraphFindingsPage';
import { FindingDetailPage } from './pages/FindingDetailPage';
import CriticalInfraPage from './pages/CriticalInfraPage';
import { CyberRangePage } from './pages/CyberRangePage';
import { OperationsHubPage } from './pages/OperationsHubPage';
import { DevGuardPage } from './pages/DevGuardPage';
import { LegalHubPage } from './pages/LegalHubPage';
import { LegalDocPage } from './pages/LegalDocPage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <NetworkScanJobProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/legal" element={<LegalHubPage />} />
          <Route path="/legal/:slug" element={<LegalDocPage />} />
          <Route path="/platform" element={<PlatformOverviewPage />} />
          <Route path="/dashboard" element={<DashboardLayout><DashboardPage /></DashboardLayout>} />
          <Route path="/operations" element={<DashboardLayout><OperationsHubPage /></DashboardLayout>} />
          <Route path="/devguard" element={<DashboardLayout><DevGuardPage /></DashboardLayout>} />
          <Route path="/critical-infrastructure" element={<DashboardLayout><CriticalInfraPage /></DashboardLayout>} />
          <Route path="/risk" element={<DashboardLayout><ScenariosPage /></DashboardLayout>} />
          <Route path="/assets" element={<DashboardLayout><AssetsPage /></DashboardLayout>} />
          <Route path="/network-scan" element={<DashboardLayout><NetworkScanPage /></DashboardLayout>} />
          <Route path="/compliance" element={<DashboardLayout><CompliancePage /></DashboardLayout>} />
          <Route path="/verification-loop" element={<DashboardLayout><VerificationLoopPage /></DashboardLayout>} />
          <Route path="/autonomous-pipeline" element={<DashboardLayout><AutonomousPipelinePage /></DashboardLayout>} />
          <Route path="/fusion/cyber-range" element={<DashboardLayout><CyberRangePage /></DashboardLayout>} />
          <Route path="/cyber-range" element={<Navigate to="/fusion/cyber-range" replace />} />
          <Route path="/runs" element={<DashboardLayout><ExecutorRunsPage /></DashboardLayout>} />
          <Route path="/runs/:runId" element={<DashboardLayout><ExecutorRunDetailsPage /></DashboardLayout>} />
          <Route path="/graph-findings" element={<DashboardLayout><GraphFindingsPage /></DashboardLayout>} />
          <Route
            path="/graph-findings/finding/:findingId"
            element={<DashboardLayout><FindingDetailPage /></DashboardLayout>}
          />
          <Route path="/registry" element={<DashboardLayout><AgentsPage /></DashboardLayout>} />
          <Route path="/remediation" element={<DashboardLayout><EvolutionPage /></DashboardLayout>} />
          <Route path="/forecasts" element={<DashboardLayout><ConfigPage /></DashboardLayout>} />
          <Route path="/reports" element={<DashboardLayout><ReportsPage /></DashboardLayout>} />
          <Route path="/resimulation" element={<DashboardLayout><SimulationPage /></DashboardLayout>} />
          <Route path="/events" element={<DashboardLayout><LogsPage /></DashboardLayout>} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
      </NetworkScanJobProvider>
    </AuthProvider>
  );
}

export default App;
